import React, { PureComponent } from 'react';
import { shape, string } from 'prop-types';
import { appendScript, handleKeyboardEvent } from '../../../../../../../../shared/utils/commonUtils';

export default class DigiCert extends PureComponent {
  static propTypes = {
    hostInfo: shape({
      hostname: string.isRequired,
    }),
  }

  static defaultProps = {
    hostInfo: {},
  }

  constructor(props) {
    super(props);
    const { hostInfo: { hostname } } = this.props;
    this.state = {
      id: hostname.indexOf('activenetwork') !== -1 ? 'HQw8qvty' : 'pdCbgRAd',
    };
  }

  componentDidMount() {
    const { id } = this.state;
    window.__dcid = window.__dcid || [];
    window.__dcid.push([ `DigiCertClickID_${id}`, '3', 'm', 'black', id ]);
    const url = '//seal.digicert.com/seals/cascade/seal.min.js';
    appendScript(url, null, true, 'head');
  }

  handleClick = () => {
    const { trackingCallback } = this.props;
    trackingCallback({ id: 'cui.digiCert.clicked' });
  }

  render() {
    const { id } = this.state;
    return (
      <span id={`DigiCertClickID_${id}`} data-language="en" className="digicert" onClick={this.handleClick} onKeyDown={handleKeyboardEvent(this.handleClick, 'Enter')}>
        <a tabIndex='-1' aria-label='wildcard-ssl-certificates' href="https://www.digicert.com/wildcard-ssl-certificates.htm"> </a>
      </span>
    );
  }
}
